import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import DefaultLayout from '../Layouts/DefaultLayout';

import ProductTitle from '../Components/ProductTitle';
import VideoPlayer from '../Components/VideoPlayer';

function App() {
    const [video, setVideo] = useState({});
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { tipo, slug, grupo, id } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchVideo = async () => {
            let redirected = false;

            try {
                const response = await fetch(`${baseUrl}/painel/materiais/${slug}/videos/${id}?tipo=${tipo}&grupo=${grupo}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        navigate('/painel/', {
                            state: {
                                message: { type: 'error', text: 'Produto não encontrado!' },
                            },
                        });
                        redirected = true;
                        return;
                    }

                    throw new Error('Erro ao buscar o vídeo.');
                }

                const data = await response.json();
                setVideo(data.video);
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            } finally {
                if (!redirected) {
                    setLoading(false);
                }
            }
        };

        fetchVideo();
    }, []);

    useEffect(() => {
        if (!video || !Number.isInteger(video.duracao)) {
            return;
        }

        const updateViews = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/materiais/${slug}/visualizar/video/${id}`, {
                    method: 'PUT',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Erro ao atualizar progresso.');
                }
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            }
        };

        const timeout = setTimeout(() => {
            updateViews();
        }, video.duracao * 800);

        return () => clearTimeout(timeout);
    }, [video.duracao]);

    return (
        <DefaultLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <ProductTitle
                            productName={video.nome}
                            loading={loading}
                            breadcrumb={[
                                { label: 'Produtos', link: `/painel/produtos/${video.tipo_slug}/` },
                                { label: video.produto_nome, link: `/painel/produtos/${video.tipo_slug}/${video.produto_slug}/` },
                                {
                                    label: video.grupo_nome,
                                    link: `/painel/produtos/${video.tipo_slug}/${video.produto_slug}/videos/${video.grupo_slug}/`,
                                },
                            ]}
                        />

                        <VideoPlayer video={video} slug={slug} id={id} accessToken={accessToken} baseUrl={baseUrl} loading={loading} />
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
